import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
import { useWatchGeolocation } from "../../../hooks/useGeolocation.js";
//#region src/modules/Locations/hooks/useLocationsNearbyCurrentUser.ts
var DEFAULT_OPTS = {
	cacheStrategy: "cache-only",
	fire: true
};
function useLocationsNearbyCurrentUser(args, opts) {
	opts = {
		...DEFAULT_OPTS,
		...opts
	};
	const geoLocation = useWatchGeolocation();
	const acceptableAccuracy = geoLocation.accuracy && geoLocation.accuracy <= 1600;
	const fire = !!(opts?.fire && geoLocation.lat && geoLocation.lng && acceptableAccuracy);
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetNearbyLocationsList.v1, geoLocation?.timestamp ? {
		lat: geoLocation.lat,
		lng: geoLocation.lng,
		maxDistance: args?.maxDistance || 3200,
		...args || {}
	} : void 0, {
		cacheStrategy: opts.cacheStrategy,
		fire
	});
	return {
		data: fire ? data : void 0,
		loading: isCalling || !data && geoLocation.loading && fire,
		refresh: call
	};
}
//#endregion
export { useLocationsNearbyCurrentUser };

//# sourceMappingURL=useLocationsNearbyCurrentUser.js.map